import { APP_ROUTES } from "../constants";

export const BannerUtil = {
  buildBannerDetailPath
};

function buildBannerDetailPath(bannerCode: string): string {
  return bannerCode ? APP_ROUTES.PAGEMANAGEMENT.BANNER.DETAIL.replace(":bannerCode", bannerCode) : APP_ROUTES.PAGEMANAGEMENT.BANNER.BASE;
}